import type { Middleware } from '@reduxjs/toolkit';
import { userActions } from './slices/user-profile/userProfieSlice';
import { trackUserOnboardedFromReduxState } from '../utils/amplitudeProductTracking';

/**
 * Fires Amplitude "User Onboarded" once per browser session when FTUE is cleared.
 */
export const amplitudeUserLifecycleMiddleware: Middleware = (store) => (next) => (action) => {
  const result = next(action);
  if (userActions.userFtueUpdate.match(action)) {
    trackUserOnboardedFromReduxState(store.getState());
  }
  return result;
};
